import { ContextProviderProps } from 'config/types'
import { createContext, Dispatch, SetStateAction, useState } from 'react'

interface SearchContextType {
  search: string
  setSearch: Dispatch<SetStateAction<string>>
}

const SearchContext = createContext<SearchContextType>({
  search: '',
  setSearch: () => {},
})

const SearchProvider = ({ children }: ContextProviderProps) => {
  const [search, setSearch] = useState('')

  return (
    <SearchContext.Provider value={{ search, setSearch }}>
      {children}
    </SearchContext.Provider>
  )
}

export { SearchProvider, SearchContext }
